import React, { useContext } from 'react';
import LeadsProvider from '../../providers/Leads/Leads.provider';
import PortfolioLeads from './PortfolioLeads.page';
import ListingContext from '../../providers/Listing/Listing.context';
import { Navigate } from 'react-router-dom';
import ReleaseFileLoadingProvider from '../../providers/ReleaseFileLoading/ReleaseFileLoading.provider';

export default (props: any) => {
  const { canManageDeal } = useContext(ListingContext);

  if (!canManageDeal) return <Navigate to="../" replace />;

  return (
    <LeadsProvider>
      <ReleaseFileLoadingProvider>
        <PortfolioLeads {...props} />
      </ReleaseFileLoadingProvider>
    </LeadsProvider>
  );
};
